(function () {
  const slideDown = (element, duration = 300) => {
    element.style.overflow = 'hidden';
    element.style.display = 'block';
    const height = element.scrollHeight;
    element.style.height = '0px';
    element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + 'px';
    setTimeout(() => {
      element.style.height = '';
      element.style.overflow = '';
      element.style.transition = '';
    }, duration);
  };

  const slideUp = (element, duration = 300) => {
    element.style.overflow = 'hidden';
    element.style.height = element.scrollHeight + 'px';
    element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = '0px';
    setTimeout(() => {
      element.style.display = 'none';
      element.style.height = '';
      element.style.overflow = '';
      element.style.transition = '';
    }, duration);
  };

  const initProductAccordion = () => {
    document.querySelectorAll(".about__accordion-toggle").forEach(toggle => {
      toggle.addEventListener("click", function() {
        const descriptions = this.parentElement.querySelectorAll(".about__accordion-description");
        const index = Array.from(this.parentElement.children).filter(el => el.classList.contains("about__accordion-toggle")).indexOf(this);
        if (!this.classList.contains("active")) {
          this.classList.add("active");
          if (descriptions[index]) slideDown(descriptions[index], 300);
        } else {
          this.classList.remove("active");
          descriptions.forEach(desc => slideUp(desc, 300));
        }
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;
    imagesWrapper.querySelectorAll('.js-image-zoom').forEach(el => {
      el.addEventListener('click', () => imagesWrapper.classList.toggle('zoom'));
    });
  };

  const initReviewAccordion = () => {
    document.querySelectorAll('.jdgm-acc details.accordion').forEach(d => {
      d.removeAttribute('open');
    });
  };

  const initReviewLoadState = () => {
    document.querySelectorAll('.product-meta-block--reviews').forEach(block => {
      if (block._reviewLoadStateInitialized) return;
      block._reviewLoadStateInitialized = true;

      const markReady = () => {
        const widget = block.querySelector('.jdgm-widget');
        if (!widget) return false;

        const isReady =
          widget.classList.contains('jdgm--leex-script-loaded') ||
          Boolean(block.querySelector('.jdgm--leex-script-loaded'));

        if (isReady) {
          block.classList.add('is-review-widget-ready');
          return true;
        }

        return false;
      };

      if (markReady()) return;

      const observer = new MutationObserver(() => {
        if (markReady()) observer.disconnect();
      });
      observer.observe(block, { attributes: true, childList: true, subtree: true });

      window.addEventListener('load', markReady, { once: true });
      setTimeout(() => {
        block.classList.add('is-review-widget-ready');
        observer.disconnect();
      }, 4000);
    });
  };

  const placeProductDescription = () => {
    const isMobile = window.matchMedia('(max-width: 1279px)').matches;

    document.querySelectorAll('[id^="MainProduct-"]').forEach(section => {
      const description = section.querySelector('[data-product-description-section]');
      const info = section.querySelector('.product__info-container');
      if (!description || !info) return;

      if (!description._originalParent) {
        description._originalParent = description.parentNode;
        description._originalNextSibling = description.nextSibling;
      }

      if (!isMobile) {
        if (description.parentNode !== description._originalParent) {
          description._originalParent.insertBefore(description, description._originalNextSibling);
        }
        return;
      }

      const price = info.querySelector('.price-wrapper');
      const title = info.querySelector('.product__title__wrapper');
      const anchor = price || title;
      if (!anchor) return;

      let insertAfter = anchor;
      if (price && price.nextElementSibling && price.nextElementSibling.classList.contains('installment-wrapper')) {
        insertAfter = price.nextElementSibling;
      }

      insertAfter.parentNode.insertBefore(description, insertAfter.nextSibling);
    });
  };

  const placeMobileBuyBlock = () => {
    const isMobile = window.matchMedia('(max-width: 1279px)').matches;

    document.querySelectorAll('[id^="MainProduct-"]').forEach(section => {
      const buyBlock = section.querySelector('.product__buy-block');
      const mobileSummary = section.querySelector('.product__mobile-summary--top');
      const gallery = section.querySelector('.product__gallery-viewer');
      if (!buyBlock || !mobileSummary) return;

      if (!mobileSummary._originalParent) {
        mobileSummary._originalParent = mobileSummary.parentNode;
        mobileSummary._originalNextSibling = mobileSummary.nextSibling;
      }

      if (!buyBlock._originalParent) {
        buyBlock._originalParent = buyBlock.parentNode;
        buyBlock._originalNextSibling = buyBlock.nextSibling;
      }

      if (!isMobile) {
        section.classList.remove('product-sticky-cta-visible');
        if (mobileSummary.parentNode !== mobileSummary._originalParent) {
          mobileSummary._originalParent.insertBefore(mobileSummary, mobileSummary._originalNextSibling);
        }
        if (buyBlock.parentNode !== buyBlock._originalParent) {
          buyBlock._originalParent.insertBefore(buyBlock, buyBlock._originalNextSibling);
        }
        return;
      }

      if (gallery && gallery.parentNode && gallery.nextSibling !== mobileSummary) {
        gallery.parentNode.insertBefore(mobileSummary, gallery.nextSibling);
      }

      if (buyBlock.parentNode !== mobileSummary.parentNode || mobileSummary.nextSibling !== buyBlock) {
        mobileSummary.parentNode.insertBefore(buyBlock, mobileSummary.nextSibling);
      }
    });
  };

  const updateMobileStickyBuyBlock = () => {
    const isMobile = window.matchMedia('(max-width: 1279px)').matches;

    document.querySelectorAll('[id^="MainProduct-"]').forEach(section => {
      if (!isMobile) {
        section.classList.remove('product-sticky-cta-visible');
        const stickyPrice = section.querySelector('.product-sticky-cta-price');
        const stickySentinel = section.querySelector('.product-sticky-cta-sentinel');
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickySentinel) stickySentinel.style.height = '0px';
        return;
      }

      const buyBlock = section.querySelector('.product__buy-block');
      const buttons = buyBlock && buyBlock.querySelector('.product-form__buttons');
      if (!buyBlock || !buttons) return;

      const mobilePrice = section.querySelector('.product__price-mobile');
      if (!buyBlock._stickyPrice) {
        buyBlock._stickyPrice = document.createElement('div');
        buyBlock._stickyPrice.className = 'product-sticky-cta-price';
        buttons.insertBefore(buyBlock._stickyPrice, buttons.firstChild);
      }
      if (mobilePrice) {
        buyBlock._stickyPrice.innerHTML = mobilePrice.innerHTML;
        buyBlock._stickyPrice.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      }

      if (!buyBlock._stickySentinel) {
        buyBlock._stickySentinel = document.createElement('span');
        buyBlock._stickySentinel.className = 'product-sticky-cta-sentinel';
        buyBlock.insertBefore(buyBlock._stickySentinel, buttons);
      }

      const isStickyVisible = section.classList.contains('product-sticky-cta-visible');
      const buttonsRect = buttons.getBoundingClientRect();
      if (!isStickyVisible) {
        buyBlock._stickyButtonsHeight = buttonsRect.height || buttons.offsetHeight || buyBlock._stickyButtonsHeight || 0;
      }

      const stickyHeight = buyBlock._stickyButtonsHeight || buttonsRect.height || buttons.offsetHeight || 0;
      const sentinelRect = buyBlock._stickySentinel.getBoundingClientRect();
      const headerHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      const headerHeight = headerHeightValue.endsWith('rem')
        ? (parseFloat(headerHeightValue) || 0) * (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16)
        : parseFloat(headerHeightValue) || 0;
      const viewportTop = Math.max(headerHeight, 0);
      const normalButtonsBottom = isStickyVisible ? sentinelRect.bottom : buttonsRect.bottom;
      const mobilePriceRect = mobilePrice ? mobilePrice.getBoundingClientRect() : null;
      const isMobilePriceVisible = mobilePriceRect
        ? mobilePriceRect.bottom > viewportTop && mobilePriceRect.top < window.innerHeight
        : false;
      const shouldShow = normalButtonsBottom <= viewportTop && !isMobilePriceVisible;
      section.classList.toggle('product-sticky-cta-visible', shouldShow);
      buyBlock._stickySentinel.style.height = shouldShow ? `${stickyHeight}px` : '0px';
      buyBlock._stickyPrice.hidden = !shouldShow || !mobilePrice;
    });
  };

  const initMobileStickyBuyBlock = () => {
    placeMobileBuyBlock();
    updateMobileStickyBuyBlock();
  };

  const initAll = () => {
    initProductAccordion();
    initZoomImage();
    initReviewAccordion();
    initReviewLoadState();
    placeProductDescription();
    initMobileStickyBuyBlock();
  };

  window.addEventListener('resize', () => {
    placeProductDescription();
    initMobileStickyBuyBlock();
  });
  window.addEventListener('scroll', updateMobileStickyBuyBlock, { passive: true });
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
